import { useState } from "react";
import { AddCandidateDialog } from "./AddCandidateDialog";
import { Button } from "@/components/ui/button";
import { Plus, Search } from "lucide-react";
import { FindMatchesModal } from "@/components/jobs/FindMatchesModal";
import { SharedKanbanBoard } from "./SharedKanbanBoard";
import { useJobKanban } from "@/hooks/jobs/useJobKanban";
import { useTranslation } from "react-i18next";

interface JobKanbanWrapperProps {
	jobId: string | undefined;
	jobSkills?: string[];
}

export const JobKanbanWrapper = ({ jobId, jobSkills = [] }: JobKanbanWrapperProps) => {
	const { t } = useTranslation();
	const {
		isAddCandidateOpen,
		setIsAddCandidateOpen,
		handleAddCandidate,
		handleAddCandidateConfirm,
		addMultipleCandidates
	} = useJobKanban(jobId);

	const [isFindMatchesModalOpen, setIsFindMatchesModalOpen] = useState(false);

	return (
		<div className="w-full">
			<div className="flex justify-end mb-4 gap-2">
				<Button 
					onClick={() => setIsFindMatchesModalOpen(true)}
					className="bg-indigo-600 hover:bg-indigo-700 flex items-center gap-1"
				>
					<Search className="h-4 w-4" />
					<span>{t("jobs.kanban.findMoreMatches")}</span>
				</Button>
				<Button 
					onClick={handleAddCandidate}
					className="bg-digger-blue hover:bg-digger-blue-light flex items-center gap-1"
				>
					<Plus className="h-4 w-4" />
					<span>{t("jobs.kanban.addCandidate")}</span>
				</Button>
			</div>

			<SharedKanbanBoard jobId={jobId} />

			<AddCandidateDialog
				isOpen={isAddCandidateOpen}
				onClose={() => setIsAddCandidateOpen(false)}
				onAddCandidate={handleAddCandidateConfirm}
			/>

			<FindMatchesModal
				isOpen={isFindMatchesModalOpen}
				onClose={() => setIsFindMatchesModalOpen(false)}
				jobId={jobId}
				jobSkills={jobSkills}
				onAddMatches={addMultipleCandidates}
			/>
		</div>
	);
};
